class BuyIngredientsSticky extends HTMLElement {
  constructor() {
    super();

    this.ingredientsList = document.querySelector('.article-recipe-card__ingredients-products.quick-bar');
    this.overlay = document.querySelector('.article-recipe-card__ingredients-products-sticky-overlay');
    this.closeButton = document.querySelector('.article-recipe-card__ingredients-products.quick-bar .article-recipe-card__ingredients-info-close');

    this.viewIngredientsButton = this.querySelector('.article-recipe-card__btn-buy-ingredients');
    this.viewIngredientsButton.addEventListener('click', this.onShowIngredientsHandler.bind(this));

    this.overlay.addEventListener('click', this.onHideIngredientsHandler.bind(this));
    this.closeButton.addEventListener('click', this.onHideIngredientsHandler.bind(this));
  }

  onShowIngredientsHandler(evt) {
    evt.preventDefault();

    document.querySelector('html').classList.add('sticky-active');

    this.ingredientsList.classList.add('active');
    this.overlay.classList.add('sticky-active');
  }

  onHideIngredientsHandler(evt) {
    evt.preventDefault();

    document.querySelector('html').classList.remove('sticky-active');

    this.overlay.classList.remove('sticky-active');
    this.ingredientsList.classList.remove('active');
  }
}

customElements.define('buy-ingredients-sticky', BuyIngredientsSticky);

class RecipeBuyIngredients extends HTMLElement {
  constructor() {
    super();

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    this.addIngredientsButton = this.querySelector('.add-all-ingredients');
    this.addIngredientsButton.addEventListener('click', this.onAddIngredientsHandler.bind(this));
  }

  onAddIngredientsHandler(evt) {
    evt.preventDefault();

    const ingredients = this.querySelectorAll('ingredients-buy-list li');

    const cartData = [];
    ingredients.forEach(ingredient => {
      cartData.push({
        id: ingredient.dataset.productId,
        quantity: ingredient.dataset.cartQty
      });
    });

    let formData = {
      'items': cartData,
      'sections': this.cart.getSectionsToRender().map((section) => section.id),
      'sections_url': window.location.pathname
     };

     if (this.cart) {
      this.cart.setActiveElement(document.activeElement);
    }

     fetch(window.Shopify.routes.root + 'cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
     })
     .then(response => {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        cartData: response,
      });
       return response.json();
     })
     .then(data => {
      this.cart.renderContents(data);
      return data;
    })
     .catch((error) => {
       console.error('Error:', error);
     })
     .finally(() => {
      if (this.cart && this.cart.classList.contains("is-empty"))
        this.cart.classList.remove("is-empty");
    });
  }

}

customElements.define('ingredients-buy-list', RecipeBuyIngredients);
